var icon_button_default = {
  "audioIconButton": "iOrQ5"
};
export {
  icon_button_default as default
};
//# sourceMappingURL=icon-button-scss.js.map
